import { serverCall } from "utils/serverCall";
import { deleteBanner, errorBannerList, errorDeleteBanner, initBannerListRequest, setBannerList, errorAddBanner, addBanner } from "./action";
import apiEndpoints from "utils/apiList";
import toast from "react-hot-toast";




export const fetchBannerList = () => {
  return async (dispatch) => {
    dispatch(initBannerListRequest());
    try {
      const result = await serverCall(apiEndpoints.BANNER_LIST, 'GET', dispatch);
      
      if (result.success && result.data) {
        dispatch(setBannerList(result.data?.payload));
      } else {
        dispatch(errorBannerList(result.message));
      }
    } catch (error) {
      dispatch(errorBannerList(error.message));
    }
  };
};

export const createBanner = (bannerData, setIsLoading, setFiles) => {
  return async (dispatch) => {
    try {
      setIsLoading(true)
      const result = await serverCall(apiEndpoints.BANNER_CREATE, 'POST', dispatch, bannerData);
      if (result.success) {
        setFiles([])
        dispatch(fetchBannerList());
        setIsLoading(false)
        dispatch(addBanner(result.data));
        // toast.success('Banner added successfully');
      } else {
        setIsLoading(false)
        toast.error(result.message);
        dispatch(errorAddBanner(result.message));
      }
    } catch (error) {
      setIsLoading(false)
      toast.error(error.message);
      dispatch(errorAddBanner(error.message));
    }
  };
};

export const deleteBannerById = (bannerId) => {
  return async (dispatch) => {
    try {
      const result = await serverCall(`${apiEndpoints.BANNER_DELETE}/${bannerId}`, 'POST', dispatch);
      if (result.success) {
        dispatch(fetchBannerList());
        dispatch(deleteBanner(bannerId));
        toast.success('Banner deleted successfully');
      } else {
        toast.error(result.message);
        dispatch(errorDeleteBanner(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorDeleteBanner(error.message));
    }
  };
};